import React, { useContext } from "react";
import KeycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";
import { getHeaderContents } from "@sia/shared/js/contents/layout";
import { Header } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";

const flagToLinkNameMap = {
  disable_login: "account",
  disable_directory: "directory",
  disable_jobs: "jobs",
  disable_agenda: "agenda",
  disable_valueApp: "valueApp",
  disable_catalog: "catalog",
  disable_wizard: "wizard",
  disable_cloud: "cloud",
  disable_benchmarking: "benchmarking",
  disable_ecom: "ecom",
  disable_shop: "shop",
  disable_term: "term",
  "disable_reference-gallery": "referenceGallery",
};

function filterItemsByDisableFlags(items, disableFlags) {
  const disabledLinkNames = disableFlags
    .map(flag => flagToLinkNameMap[flag])
    .filter(Boolean);

  return {
    ...items,
    appSwitcherLinks: items.appSwitcherLinks.filter(
      link => !disabledLinkNames.includes(link.name)
    ),
  };
}


const HeaderClient = ({
  pathFactory,
  history,
  setReferenceGalleryFilters,
  setReferenceGalleryPageArgs,
  referenceGalleryInitialFilters,
  referenceGalleryPageInitialsArgs,
  jobOffersInitialFilters,
  jobOffersPageInitialArgs,
  setJobOffersFilters,
  setJobOffersPageArgs,
  user,
  menuItems,
  i18n,
  openedHeaderDropdowns,
  setOpenedHeaderDropdowns,
  createLanguageKeyReplacedUrl,
  translate,
  headerUser,
  defaultAppSwitcherValue,
  language,
}) => {
  const { disableFlags } = useContext(GlobalContext);
  const switcherItems = React.useMemo(() => {
    const headerContentsConfig = {
      links: {
        account: {
          target: pathFactory.create("account"),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("account/customer-data"));
          },
        },
        referenceGallery: {
          target: pathFactory.create(`reference-gallery`),
          onClick: (e) => {
            e.preventDefault();
            setReferenceGalleryFilters(referenceGalleryInitialFilters);
            setReferenceGalleryPageArgs(referenceGalleryPageInitialsArgs);
            history.push(pathFactory.create("reference-gallery/search"));
          },
        },
        jobs: {
          target: pathFactory.create(`jobs`),
          onClick: (e) => {
            e.preventDefault();
            setJobOffersFilters(jobOffersInitialFilters);
            setJobOffersPageArgs(jobOffersPageInitialArgs);
            history.push(pathFactory.create("jobs/offers"));
          },
        },
        directory: {
          target: pathFactory.create(`directory`),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("directory"));
          },
        },
        agenda: {
          target: pathFactory.create(`agenda`),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("agenda"));
          },
        },
        valueApp: {
          target: pathFactory.create(`value-app`),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("value-app"));
          },
        },
        catalog: {
          target: pathFactory.create("catalog"),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("catalog"));
          },
        },
        wizard: {
          target: pathFactory.create(`wizard`),
          onClick: (e) => {
            e.preventDefault();
            history.push(pathFactory.create("wizard"));
          },
        },
        cloud: {
          target: process.env.REACT_APP_CLOUD_IDP_LINK,
        },
        benchmarking: {
          target: process.env.REACT_APP_BENCHMARKING_URL,
        },
      },
    };
    let items = { ...getHeaderContents(headerContentsConfig) };
    if (user?.isMemberTypeGroupOf("corporate")) {
      items = {
        ...items,
        appSwitcherLinks: items.appSwitcherLinks.filter((e) => e.name !== "cloud"),
      };
    }
    items = filterItemsByDisableFlags(items, disableFlags);
    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, disableFlags]);
  const isUserLoggedIn = KeycloakIDPAdapter.isLoggedIn();
  return (
    <Header
      menuItems={menuItems}
      sharedContents={switcherItems}
      selectedLanguageKey={i18n.language}
      logoLinking={() => history.push("/")}
      openedDropdowns={openedHeaderDropdowns}
      toggleDropdowns={(updatedOpenedDropdowns) => setOpenedHeaderDropdowns(updatedOpenedDropdowns)}
      onChangeLanguage={(languageKey) => {
        localStorage.setItem("sia.webPlatform.languageKey", languageKey);
        const languageKeyReplacedUrl = createLanguageKeyReplacedUrl(languageKey);
        window.location.replace(languageKeyReplacedUrl);
      }}
      onClickLogin={() => {
        window.location.href = KeycloakIDPAdapter.createLoginUrl(i18n.language);
      }}
      onClickLogout={() => KeycloakIDPAdapter.logout()}
      translate={translate}
      isUserLoggedIn={isUserLoggedIn}
      user={headerUser}
      defaultAppSwitcherValue={defaultAppSwitcherValue}
      search={true}
      history={history}
      lang={language}
      showUser={!disableFlags?.includes("disable_login")}
      showAppSwitcher={switcherItems?.appSwitcherLinks.length > 0}
    />
  );
};

export default HeaderClient;
